import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';
import * as mHeaderActions from '../actions/mHeaderActions';
import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';


/**
 * Resolves SuperLink `to` into navigation metadata.
 * @returns {{ kind: 'internal', href: string } | { kind: 'hash', hash: string } | { kind: 'native', href: string } | { kind: 'blocked' } | null}
 */
export function resolveSuperLinkHref(to) {
  if (!to) return null;

  let resolved = to.replace(/(?:\[cms]|\[CMS])/g, () => apiValues.getCmsUploadBase());
  resolved = resolved.trim();

  if (/^javascript:/i.test(resolved)) return {kind: 'blocked'};
  if (/^mailto:/i.test(resolved) || /^tel:/i.test(resolved)) {
    return {kind: 'native', href: resolved};
  }
  if (/^\/\//.test(resolved)) {
    const protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';
    return {kind: 'native', href: `${protocol}${resolved}`};
  }
  if (resolved.indexOf('://') >= 0) {
    return {kind: 'native', href: resolved};
  }
  if (resolved.startsWith('#')) {
    return {kind: 'hash', hash: resolved === '#' ? '' : resolved};
  }
  if (resolved !== '/' && !resolved.startsWith('/')) {
    resolved = `/${resolved}`;
  }
  return {kind: 'internal', href: resolved};
}


class SuperLink extends React.Component{
  link_onClick = (e) => {
    this.props.actions.mHeaderActions.menuToggle(false);
    this.props.actions.mHeaderActions.toggleAllTabs(false);
    this.props.actions.mHeaderActions.expandedTab({
      expandedTabBarVisible: false,
      expandedTabBarWidth: 0,
      expandedTab: '',
    });
    if (this.props.onClick) this.props.onClick(e);
  };

  className = () => `superlink ${this.props.className || ''}`.trim();

  renderLinkContent = () => this.props.children;

  elementProps(){
    const {
      to, className, children, onClick, target, cmsId,
      actions, history, location, match, navigationLink,
      ...rest
    } = this.props;
    return rest;
  }

  render(){
    const resolved = resolveSuperLinkHref(this.props.to);
    const className = this.className();
    const elementProps = this.elementProps();

    if (!resolved) {
      if (this.props.onClick) {
        return (
          <button type="button"
                  className={className}
                  onClick={this.link_onClick}
                  {...elementProps}>
            {this.renderLinkContent()}
          </button>
        );
      }
      return <span className={className}>{this.renderLinkContent()}</span>;
    }

    if (resolved.kind === 'blocked') {
      return <span className={className}>{this.renderLinkContent()}</span>;
    }

    if (resolved.kind === 'native') {
      const target = this.props.target;
      const rel = target === '_blank' ? 'noopener noreferrer' : undefined;
      return (
        <a href={resolved.href}
           className={className}
           target={target || undefined}
           rel={rel}
           onClick={this.link_onClick}
           {...elementProps}>
          {this.renderLinkContent()}
        </a>
      );
    }

    if (resolved.kind === 'hash') {
      const {pathname, search} = this.props.location;
      return (
        <Link to={{pathname, search, hash: resolved.hash}}
              className={className}
              onClick={this.link_onClick}
              {...elementProps}>
          {this.renderLinkContent()}
        </Link>
      );
    }

    return (
      <Link to={resolved.href}
            className={className}
            onClick={this.link_onClick}
            {...elementProps}>
        {this.renderLinkContent()}
      </Link>
    );
  }
}


export default withRouter(connect(
  (state, ownProps) => (
    ownProps.cmsId ? {navigationLink: helpers.getById(state.navigationLink, ownProps.cmsId)} : {}
  ),
  (dispatch) => ({
    actions: {
      mHeaderActions: bindActionCreators(mHeaderActions, dispatch),
    },
  }),
)(SuperLink));


SuperLink.propTypes = {
  actions: PropTypes.object,
  children: PropTypes.any,
  className: PropTypes.string,
  history: PropTypes.object,
  location: PropTypes.object,
  onClick: PropTypes.func,
  target: PropTypes.string,
  to: PropTypes.string,
};
